export default class StringHelper {
    static plural(
        word: string[],
        num: number,
    ): string {
        const forms = word;
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
                ? forms[1]
                : forms[2];
    }

    /**
     * Делает capitalize у строки
     * @static
     */
    static capitalize(word: string) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
}
